import { levenshteinDistanceInsertionsOnly } from './fuzzySearchHelpers';

export function hasMatchOnKeyUsingFuzzySearch(
  searchValue: string,
  targetKey: string,
  fuzzySearchThreshold: number
): boolean {
  const distance = levenshteinDistanceInsertionsOnly(searchValue, targetKey);

  return distance !== -1 && distance <= fuzzySearchThreshold;
}

export function fuzzySearchResults<T extends { key: string }>(
  matchTerm: string,
  data: T[],
  distanceThreshold: number
): { distance: number; data: T }[] {
  const results =
    data
      ?.reduce<{ distance: number; data: T }[]>((acc, nextData) => {
        const distance = levenshteinDistanceInsertionsOnly(
          matchTerm,
          nextData.key.toLowerCase()
        );

        if (distance > distanceThreshold) {
          return acc;
        }

        const levenshteinObj = { distance, data: nextData };

        acc.push(levenshteinObj);
        return acc;
      }, [])
      .sort((a, b) => a.distance - b.distance) ?? [];

  return results;
}
